<template>
  <div class="pructrch">
    <div class="pructrch-background" @scroll="BaCoScrollqb($event)">
      <div class="pructrch-backmap">
        <div class="pructrch-search">
          <div class="pructrch-search-relvus">
            <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
          </div>
          <div class="pructrch-search-retval">
            <router-link :to="{path:'seaducts'}"><el-input v-model="prfructs" disabled></el-input></router-link>
          </div>
        </div>
        <div class="pructrch-otymde" v-for="erprarchte in prarchte" :key="erprarchte.ID">
          <router-link :to="{path:'commodity',query: {hmComyID: erprarchte.ID}}">
            <div class="pructrch-otymde-pict">
              <img :src="erprarchte.GOODS_IMAGE" alt="">
            </div>
            <div class="pructrch-otymde-intr">
              <p class="pructrch-otymde-intr-title">{{erprarchte.GOODS_NAME}}</p>
              <p class="pructrch-otymde-intr-number" v-if="maluerID == '0'"><span>￥</span>{{erprarchte.MARKET_PRICE}}</p>
              <p class="pructrch-otymde-intr-number" v-else-if="maluerID == '1'">{{erprarchte.PRICE}}</p>
              <p class="pructrch-otymde-intr-conter">{{erprarchte.merchantsName}}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      prfructs: '',
      prarchte: '',
      maluerID: ''
      // shodagesng: 1,
      // shprctes: ''
    }
  },
  created () {
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 接收搜索传过来的值
    this.prfructs = this.$route.query.sefructs;
    // 要搜索的商品
    this.$axios.post('wx/mall/page',this.$qs.stringify({
      KEYWORDS: this.prfructs,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      if(res.data.result == 'success'){
        this.prarchte = res.data.varList;
      }
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
  },
  mounted () {

  },
  methods: {
    // 滚动条触底的时候触发
    // BaCoScrollqb(e) {
    //   // 滚动条卷起的高度
    //   let scrollTop = e.target.scrollTop;
    //   let scrollHeight = e.target.scrollHeight;
    //   let offsetHeight = Math.ceil(e.target.getBoundingClientRect().height);
    //   let currentHeight = scrollTop + offsetHeight;
    //   if(currentHeight - scrollHeight > 0 && this.shodagesng < this.shprctes){
    //     this.shodagesng = this.shodagesng + 1;
    //     // 滚动条触底的时候渲染新的数据
    //     this.$axios.post('wx/mall/page',this.$qs.stringify({
    //       showCount: '6',
    //       currentPage: this.shodagesng,
    //       MALL_TYPE: this.maluerID
    //     }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    //     .then(res => {
    //       this.shcomdty = [...this.shcomdty,...res.data.varList];
    //     })
    //     .catch(() => {
    //       // console.log('未登录获取数据失败');
    //     });
    //   }
    // },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/pructrch.css";
</style>